export enum ReviewEnum {
  CAROUSEL = 'CAROUSEL',
  IMAGE = 'IMAGE'
}
